import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import './assets/css/AllCss.css'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

// 引入时钟数字体
import '@/assets/font/fonts.css';

import vue3videoPlay from "vue3-video-play"; // 引入组件
import "vue3-video-play/dist/style.css"; // 引入css


//引入element ui icons
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
//引入iconfont 字体图标
import './assets/iconfont/iconfont.css'

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(router).use(ElementPlus, { locale: zhCn, }).use(createPinia().use(piniaPluginPersistedstate)).use(vue3videoPlay).mount('#app');
